import { asyncWithLDProvider } from "launchdarkly-react-client-sdk";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "primereact/resources/themes/lara-light-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";
import "./App.css";
import "./config.css";
import "./index.css";
import "./primereact-brand.css";
import { PrimeReactProvider } from "primereact/api";
import App from "./App";
import BodyFooter from "./components/app/bodyFooter";
import { Config } from "./config/api.js";
import { LangContext } from "./context";
import Registry from "./libs/register_storage";
import { Auth0Provider } from "./reactAuth0Wrapper";

import "semantic-ui-css/semantic.min.css"; // keep last in order to overrule global CSS
import "./semantic-ui-compat.css"; // TODO: remove when Semantic UI migration is complete

// A function that routes the user to the right place
// after login
const onRedirectCallback = (appState) => {
  const url = appState?.targetUrl || window.location.pathname;
  window.history.replaceState({}, document.title, url);
};

const storage = new Registry(window.localStorage);
const redirectUrl = `${window.location.origin}${Config.basename}`;
const LANG = (client) => {
  return require(`./assets/client/${client}/lang.json`);
};
const container = document.getElementById("root");
if (!container) throw new Error('Root element "#root" not found');
const root = createRoot(container);

(async () => {
  const LDProvider = await asyncWithLDProvider({
    clientSideID: process.env.REACT_APP_LD_CLIENT_ID,
    user: { key: storage.getItem("organization") || 0 },
  });

  root.render(
    <StrictMode>
      <PrimeReactProvider>
        <Auth0Provider
          domain={Config.auth0.domain}
          client_id={Config.auth0.clientId}
          redirect_uri={redirectUrl}
          onRedirectCallback={onRedirectCallback}
        >
          <LDProvider>
            <LangContext.Provider value={LANG(Config.public_client)}>
              <App />
              <BodyFooter />
            </LangContext.Provider>
          </LDProvider>
        </Auth0Provider>
      </PrimeReactProvider>
    </StrictMode>,
  );
})();
